"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxCreateAccountArgs = void 0;
function serializeHxCreateAccountArgs(_arg) {
    var output = [];
    output.push(_arg.displayName);
    output.push(_arg.emailAddress);
    output.push(_arg.incomingServerAddress);
    output.push(_arg.incomingServerPort);
    output.push(_arg.incomingServerSslScheme);
    output.push(_arg.incomingServerUsername);
    output.push(_arg.incomingServerPassword.unprotect());
    output.push(_arg.webAccountId);
    output.push(_arg.targetAccountId.toString());
    output.push(_arg.syncDeviceAccountTypeId);
    output.push(_arg.authType);
    output.push(_arg.userDisplayName);
    output.push(_arg.refreshToken !== undefined);
    if (_arg.refreshToken !== undefined) {
        output.push(_arg.refreshToken.unprotect());
    }
    output.push(_arg.remoteRefreshToken !== undefined);
    if (_arg.remoteRefreshToken !== undefined) {
        output.push(_arg.remoteRefreshToken.unprotect());
    }
    output.push(_arg.activeSyncDomain);
    output.push(_arg.outgoingServerAddress);
    output.push(_arg.outgoingServerPort);
    output.push(_arg.outgoingServerSslScheme);
    output.push(_arg.outgoingServerUsername);
    output.push(_arg.outgoingServerPassword.unprotect());
    output.push(_arg.outgoingServerAuthenticationRequired);
    output.push(_arg.creationState);
    output.push(_arg.type);
    output.push(_arg.exchangeForestType);
    output.push(_arg.skipHxAccountsAppActiveCheck);
    output.push(_arg.accessToken.unprotect());
    output.push(_arg.accessTokenExpiration.valueOf());
    output.push(_arg.onPremiseUriForCloudCache);
    output.push(_arg.onPremisePortForCloudCache !== undefined);
    if (_arg.onPremisePortForCloudCache !== undefined) {
        output.push(_arg.onPremisePortForCloudCache);
    }
    output.push(_arg.primaryAccountIdForSharedAccount.toString());
    output.push(_arg.popLeaveOnServer !== undefined);
    if (_arg.popLeaveOnServer !== undefined) {
        output.push(_arg.popLeaveOnServer);
    }
    output.push(_arg.cloudEnvironmentForAAD !== undefined);
    if (_arg.cloudEnvironmentForAAD !== undefined) {
        output.push(_arg.cloudEnvironmentForAAD);
    }
    output.push(_arg.sslCertificateValidation !== undefined);
    if (_arg.sslCertificateValidation !== undefined) {
        output.push(_arg.sslCertificateValidation);
    }
    return output;
}
exports.serializeHxCreateAccountArgs = serializeHxCreateAccountArgs;
